import React from 'react';
import SharedLogin from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/authentication/login';
import { Reference } from 'types/reference';
import { NextFrontasticImage } from 'frontastic/lib/image';
import LoginForm from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/authentication/login/login-form';
import { LOOM_AUTH_LOOK } from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/authentication/auth-look';

export interface LoginProps {
  signInLink: Reference;
  accountLink?: Reference;
  logo: NextFrontasticImage;
  src: string;
  onLogin?: () => void;
}

const Login: React.FC<LoginProps> = ({ onLogin, logo, src }) => {
  return (
    <SharedLogin>
      <LoginForm onLogin={onLogin} logo={logo} src={src} look={LOOM_AUTH_LOOK} />
    </SharedLogin>
  );
};

export default Login;
